/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */

import React, { useEffect } from 'react';
import { useAppSelector } from '../../../reducers';
import { getCurrentUser } from '../../../selectors/user';
import { BaseStepCompProps } from '../types';
import EnvelopesIcon from '../../../images/envelopes.svg';

export const VerifyEmail = (props: Pick<BaseStepCompProps, 'goToStep' | 'handleNext' | 'formData'>) => {
  const { formData, goToStep, handleNext } = props;

  const currentUser = useAppSelector(getCurrentUser);

  useEffect(() => {
    if (currentUser) {
      if (!currentUser.active) {
        return;
      }
      // User is logged in and active, so go to next step
      return handleNext();
    }

    const isValidForm = formData.email && formData.password;
    if (!isValidForm) {
      // Accessing this page without going through signup is not allowed, so send them back
      goToStep();
    }
  }, [formData, currentUser, goToStep, handleNext]);

  return (
    <div className='onboarding-form'>
      <section className='title-container text-center position-relative' style={{ minHeight: '400px' }}>
        <div className='watermark-background'>
          <img src={EnvelopesIcon} alt='email-sent' />
        </div>

        <div className='position-relative'>
          <div className='h1 text-medium text-ThemeAccentExtradark'>Check your email</div>

          <div className='mt-5 text-lg'>
            <p>We’ve sent a verification link to your email address.</p>
            <p>Please check your email inbox at </p>
            <p className='text-strong'>{formData.email}</p>
            <p>and click the link to activate your account.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
